// Extensiones de adjuntos permitidas para subir en documentos relacionados 
const EXTENSIONES_VERIFACTU = [
  'XML',
  'ZIP'
]

export {
  EXTENSIONES_VERIFACTU
}
